import { TranslationProvider } from "$/components/translation-provider"
import { Toaster } from "@repo/ui/components/ui/toaster"
import { QueryClient } from "@tanstack/react-query"
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <TranslationProvider>
      <Outlet />
      <Toaster />
    </TranslationProvider>
  ),
})
